import { taggedTemplateLiteralLoose as _taggedTemplateLiteralLoose } from '../../_virtual/_rollupPluginBabelHelpers.js';
import { Card, inlineMediaQueryMixin, token } from '@zillow/constellation';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import { ColorCardMixin } from '../../mixins/components/ColorCardMixin.js';
import customPropTypes from '../../utils/custom-prop-types.js';
import { StyledCardImage } from '../CardImage/CardImage.js';

var _templateObject, _templateObject2, _templateObject3;
var marginTopBottomCSS = function marginTopBottomCSS(mediaProps) {
  return css(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n    margin-top: -", "px;\n    margin-bottom: ", "px;\n"])), token("spacing." + mediaProps.paddingTop), token("spacing." + mediaProps.paddingTop));
};
var marginRightCSS = function marginRightCSS(mediaProps) {
  return css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteralLoose(["\n    margin-right: -", "px;\n"])), token("spacing." + mediaProps.paddingRight));
};
var marginLeftCSS = function marginLeftCSS(mediaProps) {
  return css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteralLoose(["\n    margin-left: -", "px;\n"])), token("spacing." + mediaProps.paddingLeft));
};
var ColorCard = /*#__PURE__*/styled(Card).withConfig({
  componentId: "sc-ux4u3e-0"
})(["", " ", "{", " ", " ", "}"], ColorCardMixin, StyledCardImage, inlineMediaQueryMixin('paddingTop', marginTopBottomCSS), inlineMediaQueryMixin('paddingLeft', marginLeftCSS), inlineMediaQueryMixin('paddingRight', marginRightCSS));
ColorCard.propTypes = {
  backgroundColor: customPropTypes.inlineMediaQuery(PropTypes.string),
  fontColor: customPropTypes.inlineMediaQuery(PropTypes.string)
};
ColorCard.defaultProps = {};
/** @component */
var ColorCard$1 = ColorCard;

export { ColorCard$1 as default };
